import {
  AdditionalMailingAudience,
  AdditionalMailingType,
} from "src/store/additionalMailing/types";

export const ADDITIONAL_MAILING_TYPE_LABEL: {
  [key in AdditionalMailingType]: string;
} = {
  vote_reminder: "Vote Reminder",
  informational: "Informational",
  contesting_party_announcement: "Contesting Party Announcement",
  contesting_party_vote_reminder: "Contesting Party Vote Reminder",
  contesting_party_informational: "Contesting Party Informational",
};

export const ADDITIONAL_MAILING_AUDIENCE_LABEL: {
  [key in AdditionalMailingAudience]: string;
} = {
  all_shareholders: "All Shareholders",
  not_voted_shareholders: "Not Voted Shareholders",
};
